import {
  AllowedDeniedIdAndLabel,
  BrandAndMarketListItem,
  FieldPermissionIdAndLabel,
  SectionPermissionIdAndLabel,
} from "../../../integrated-client/models";

export interface IPermissionListItem {
  brandAndMarket?: BrandAndMarketListItem;
  restriction?: FieldPermissionIdAndLabel;
}

export interface IPermissionsData {
  adminPortal?: AllowedDeniedIdAndLabel;
  userPermissions?: SectionPermissionIdAndLabel;
  searchManager?: Array<IPermissionListItem> | null;
  searchManagerDiagnostics?: AllowedDeniedIdAndLabel;
  bookingCreateManagerOsis?: Array<IPermissionListItem> | null;
  bookingCreateManagerRemarks?: Array<IPermissionListItem> | null;
  regions?: SectionPermissionIdAndLabel;
  countries?: SectionPermissionIdAndLabel;
  cities?: SectionPermissionIdAndLabel;
  airports?: SectionPermissionIdAndLabel;
  airlines?: SectionPermissionIdAndLabel;
  agencies?: Array<IPermissionListItem> | null;
  agencyGroups?: Array<IPermissionListItem> | null;
  providerCredentials?: Array<IPermissionListItem> | null;
  providerPreferences?: Array<IPermissionListItem> | null;
  identityProviderSettings?: Array<IPermissionListItem> | null;
  identitySettings?: Array<IPermissionListItem> | null;
  markups?: Array<IPermissionListItem> | null;
  ticketTLO?: Array<IPermissionListItem> | null;
  shoppingDiagnostics?: AllowedDeniedIdAndLabel;
  markupDiagnostics?: AllowedDeniedIdAndLabel;
  brands?: SectionPermissionIdAndLabel;
  markets?: SectionPermissionIdAndLabel;
  distributionChannels?: SectionPermissionIdAndLabel;
  globalFilters?: Array<IPermissionListItem> | null;
  activityLog?: AllowedDeniedIdAndLabel;
  ancillarySuppliers?: SectionPermissionIdAndLabel;
  ancillaryDistributions?: Array<IPermissionListItem> | null;
  technicalLogs?: AllowedDeniedIdAndLabel;
  geoGroups?: SectionPermissionIdAndLabel;
  suppliers?: SectionPermissionIdAndLabel;
  vccCredentials?: Array<IPermissionListItem> | null;
  ssrRules?: Array<IPermissionListItem> | null;
  bookingTolerances?: Array<IPermissionListItem> | null;
  ancillaryManager?: SectionPermissionIdAndLabel | null;
}

export interface IUserData {
  accountEnabled?: boolean | null;
  creationDate?: Date;
  displayName?: string | null;
  givenName?: string | null;
  id?: string | null;
  oneAirAdminRole?: string | null;
  surname?: string | null;
  emailAddress?: string | null;
  permissions?: IPermissionsData;
}

export interface IUserPermissionsEditorData {
  userData?: IUserData;
  validation?: any;
}
export class UserPermissionsEditorData implements IUserPermissionsEditorData {
  userData?: IUserData;
  validation?: any;
}
